import { c as _c } from "react/compiler-runtime";
import IconAlert from '@/components/assets/icon_alert.svg';
import DefaultAlertDialog from '@/components/DefaultAlertDialog';
import { useUAContext } from '@/context/UAContext';
import { useTranslations } from 'next-intl';
type VramAlertModalProps = {
  onCancel?: () => void;
  onAction?: () => void;
};
export default function VramAlertModal(t0) {
  const $ = _c(20);
  const {
    onCancel,
    onAction
  } = t0;
  const t = useTranslations();
  const {
    deviceType
  } = useUAContext();
  const isDesktop = deviceType === "desktop";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconAlert className="h-[40px] w-[40px] fill-[#F8E64A]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isDesktop ? "loading-screen.performance-alert-pc.title" : "loading-screen.performance-alert.title";
  let t3;
  if ($[1] !== t || $[2] !== t2) {
    t3 = t(t2);
    $[1] = t;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isDesktop ? "loading-screen.performance-alert-pc.description" : "loading-screen.performance-alert.description";
  let t5;
  if ($[4] !== t || $[5] !== t4) {
    t5 = t(t4);
    $[4] = t;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <p className="body1-omni-styles text-vive-primary-20">{t5}</p>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("loading-screen.performance-alert.continue");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t("loading-screen.performance-alert.go-trailer");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== onAction || $[14] !== onCancel || $[15] !== t3 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <DefaultAlertDialog open={true} titleIcon={t1} title={t3} content={t6} cancelText={t7} actionText={t8} onCancel={onCancel} onAction={onAction} allowOutsideInteraction={true} />;
    $[13] = onAction;
    $[14] = onCancel;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}